import { patch } from '@rails/request.js'

import divide from 'lodash/divide'
import clamp from 'lodash/clamp'

import { useClickOutside } from "stimulus-use"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['wrapper', 'image', 'button']
  static values = {
    pannable: { type: Boolean, default: true },
    attribute: String,
    updateUrl: String
  }

  static get shouldLoad(){
    return JSON.parse(document.body.dataset.editable)
  }

  initialize() {
    this.element.addEventListener('turbo:before-morph-attribute', (event) => {
      if (this.hasWrapperTarget && event.target === this.wrapperTarget &&
        this.wrapperTarget.classList.contains('is-active')) {

        event.preventDefault()
      }
    })

    this.element.addEventListener('turbo:before-morph-attribute', (event) => {
      if (event.target === this.buttonTarget) {
        event.preventDefault()
      }
    })

    useClickOutside(this, { events: ['pointerdown'] })

    this.startPosY = 0
    this.dragging = false
    this.boundDrag = this.drag.bind(this)

    if (this.pannableValue && this.imageTarget.complete) {
      this.calculateSize()
    }
  }

  pannableValueChanged() {
    if (this.pannableValue) {
      this.buttonTarget.classList.remove('is-hidden')
    } else {
      this.buttonTarget.classList.add('is-hidden')
    }
  }

  enable() {
    this.pannableValue = true
  }

  disable() {
    this.pannableValue = false
  }

  start() {
    this.wrapperTarget.classList.add('is-active')
  }

  end() {
    if (this.wrapperTarget.classList.contains('is-active')) {
      patch(this.updateUrlValue, {
        body: {
          [this.attributeValue]: this.imageTarget.style.objectPosition
        },
        responseKind: 'turbo-stream'
      })

      this.wrapperTarget.classList.remove('is-active')
    }
  }

  clickOutside() {
    if (this.pannableValue) { this.end() }
  }

  calculateSize() {
    const scaleRatio = divide(this.imageTarget.clientWidth, this.imageTarget.naturalWidth)
    const scaledHeight = this.imageTarget.naturalHeight * scaleRatio
    const heightDifference = scaledHeight - this.imageTarget.clientHeight

    this.heightDifferenceRatio = divide(100, heightDifference)
  }

  beginDrag(event) {
    event.preventDefault()

    this.startPosY = event.clientY

    this.dragging = true
    document.addEventListener('pointermove', this.boundDrag)
  }

  endDrag(event) {
    if (this.dragging) {
      event.preventDefault()

      document.removeEventListener('pointermove', this.boundDrag)
      this.dragging = false
    }
  }

  drag(event) {
    const relativeMovement = this.startPosY - event.clientY
    this.startPosY = event.clientY

    const splitObjectPosition = this.imageTarget.style.objectPosition.split(/\s+/)
    const currentYPosition = parseFloat(splitObjectPosition[1] || splitObjectPosition[0])
    const relativeMovementPercentage = relativeMovement * this.heightDifferenceRatio
    const newYPosition = clamp(currentYPosition + relativeMovementPercentage, 0, 100)

    this.imageTarget.style.objectPosition = `50% ${newYPosition}%`
  }
}
